import React, { useEffect, useState } from "react";

import moment from "moment";
import { OrderProps, OrderPartyProps, OrderJobworkPartyProps } from "../../types/order";

type Props = {
  order: OrderProps;
  partyInfo?: OrderPartyProps | OrderJobworkPartyProps;
};

const OrderPdf = ({ order, partyInfo }: Props) => {
  const companyName = process.env.REACT_APP_COMPANY_NAME_EN;
  const companyNameGu = process.env.REACT_APP_COMPANY_NAME_GU;
  const displayParty = partyInfo || order.party;

  const [rotate, setRotate] = useState(false);

  useEffect(() => {
    const timestamp = moment().format("DD-MM-YYYY HH:mm:ss");
    document.title = `${companyNameGu} ઓર્ડર ડિટેલ ${timestamp}`;
  }, [companyNameGu]);

  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      if (img.height > img.width) {
        setRotate(true);
      }
    };
    img.src = order.image;
  }, [order.image]);

  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        height: "148mm",
        width: "105mm",
        padding: "5mm",
        overflow: "hidden",
        boxSizing: "border-box",
        backgroundColor: "white",
      }}
    >
      <h1
        style={{
          fontSize: "18px",
          fontWeight: "bold",
          color: "black",
          textAlign: "center",
          margin: "0 0 2mm 0",
        }}
      >
        {companyName}
      </h1>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "2mm",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "1mm" }}>
          <p
            style={{
              fontSize: "12px",
              color: "black",
              fontWeight: 600,
              margin: 0,
            }}
          >
            <span style={{ fontWeight: "bold", marginRight: "5mm" }}>
              પાર્ટી
            </span>
            : {displayParty?.firm_name}
          </p>
          <p
            style={{
              fontSize: "12px",
              color: "black",
              fontWeight: 600,
              margin: 0,
            }}
          >
            <span style={{ fontWeight: "bold", marginRight: "2mm" }}>
              તારીખ
            </span>
            :{" "}
            {order?.created_at
              ? moment(order?.created_at, "YYYY-MM-DD HH:mm:ss").format(
                  "DD-MM-YYYY"
                )
              : ""}
          </p>
          <p
            style={{
              fontSize: "12px",
              color: "black",
              fontWeight: 600,
              margin: 0,
            }}
          >
            <span style={{ fontWeight: "bold", marginRight: "4mm" }}>સમય</span>:{" "}
            {order?.created_at
              ? moment(order?.created_at, "YYYY-MM-DD HH:mm:ss").format(
                  "hh:mm A"
                )
              : ""}
          </p>
        </div>
        <p
          style={{
            fontSize: "12px",
            color: "black",
            fontWeight: 600,
            margin: 0,
          }}
        >
          <span style={{ fontWeight: "bold" }}>ઓર્ડર નં.</span>: {order?.id}
        </p>
      </div>

      <div
        style={{
          width: "100%",
          height: "65mm",
          padding: "3mm",
          marginTop: "3mm",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {order?.image && (
          <img
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",
              transform: rotate ? "rotate(90deg)" : "none",
            }}
            src={`${order.image}?order=${order.id}`}
            alt=""
          />
        )}
      </div>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginTop: "3mm",
        }}
      >
        <tbody>
          <tr>
            <td
              style={{
                fontSize: "12px",
                color: "black",
                padding: "1.5mm 2mm",
                fontWeight: "bold",
                width: "25mm",
                border: "1px solid black",
              }}
            >
              આઈટમ :
            </td>
            <td
              style={{
                fontSize: "12px",
                color: "black",
                padding: "1.5mm 2mm",
                fontWeight: 600,
                border: "1px solid black",
              }}
            >
              {order?.item?.name || ""}
            </td>
          </tr>
          <tr>
            <td
              style={{
                fontSize: "12px",
                color: "black",
                padding: "1.5mm 2mm",
                fontWeight: "bold",
                width: "25mm",
                border: "1px solid black",
              }}
            >
              સાઈઝ :
            </td>
            <td
              style={{
                fontSize: "12px",
                color: "black",
                padding: "1.5mm 2mm",
                fontWeight: 600,
                border: "1px solid black",
              }}
            >
              {order?.process?.name || ""}
            </td>
          </tr>
          <tr>
            <td
              style={{
                fontSize: "12px",
                color: "black",
                padding: "1.5mm 2mm",
                fontWeight: "bold",
                width: "25mm",
                border: "1px solid black",
              }}
            >
              નંગ :
            </td>
            <td
              style={{
                fontSize: "12px",
                color: "black",
                padding: "1.5mm 2mm",
                fontWeight: 600,
                border: "1px solid black",
              }}
            >
              {order?.qty || ""}
            </td>
          </tr>
          <tr>
            <td
              style={{
                fontSize: "12px",
                color: "black",
                padding: "1.5mm 2mm",
                fontWeight: "bold",
                width: "25mm",
                border: "1px solid black",
              }}
            >
              પરત નંગ :
            </td>
            <td
              style={{
                fontSize: "12px",
                color: "black",
                padding: "1.5mm 2mm",
                fontWeight: 600,
                border: "1px solid black",
              }}
            >
              {order?.delivered_qty || ""}
            </td>
          </tr>
        </tbody>
      </table>

      <div style={{ pageBreakAfter: "always", breakAfter: "page" }}></div>
    </div>
  );
};
export default OrderPdf;
